




























import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import { Transceiver, TransceiversApi, ThingGroup, ThingGroupsApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';

@Component({
	components: {
		secondaryNav,
		DataTableWithFilters,
		RouterLinkButton,
	},
})
export default class TransceiversList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'name', label: 'Ota Group' }, // , sortable: true
			{ key: 'firmwareVersion', label: 'Version' }, // , sortable: true
		],
		loading: false,
		search: null,
		sortBy: 'name',
		primaryKey: 'name',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		/*    {
            label: 'Sensor Assignment',
            field: 'type',
            value: false,
            type: 'checkboxes',
            options: [
                {text: 'Unassigned', value: null},
                {text: 'Vat Temp', value: 'vatTemp'},
            ],
        },*/

		{
			label: 'Active',
			field: 'active',
			value: false,
			type: 'checkbox',
		},
	];

	private api: ThingGroupsApi;

	constructor() {
		super();
		this.api = new ThingGroupsApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'thing-groups-datatable');
	}

	public clickTable(item: ThingGroup, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'thing-groups.edit',
				params: { thingGroupName: item.name },
			} as any);
			window.open(routeData.href);
		} else {
			this.$router.push({
				name: 'thing-groups.edit',
				params: { thingGroupName: item.name },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];

		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});

			if (this.state.search) {
				filters.push({ field: 'name', value: this.state.search });
			}

			// const response = await this.api.getThingGroups(
			//    ApiUtils.queryOptions(filters, ctx, {params: {include: ''}} ),
			// );
			const response = await this.api.getThingGroups(
				ApiUtils.queryOptions(filters, ctx, {
					params: { include: 'transceivers,transceivers.site' },
				}),
			);

			data = response.data.data.sort((a, b) => (a.name > b.name ? 1 : -1));

			data = response.data.data;
			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;

			console.log(e);
		}
		return data;
	}
}
